import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const ImprintPage = () => (
  <div className="site legal-page">
    <header className="legal-header">
      <Link className="brand" to="/" aria-label="Zurück zur Layla Food Startseite"><img src={logo} alt="Layla Food" /></Link>
      <Link className="head-cta" to="/">Zurück zur Startseite</Link>
    </header>

    <main className="legal-main">
      <p className="eyebrow">Rechtliches</p>
      <h1>Impressum</h1>
      <div className="legal-content">
        <section>
          <h2>Kontakt</h2>
          <p><strong>Layla Food</strong><br />Inhaber: Hasan Sengönül<br />Nienburger Str. 1a<br />27232 Sulingen</p>
          <p>E-Mail: <a href="mailto:info@layla-food.de">info@layla-food.de</a><br />Telefon: <a href="tel:+494271955255">0 42 71 / 955 255</a></p>
        </section>

        <section>
          <h2>Umsatzsteuer-ID</h2>
          <p><strong>DE416847167</strong></p>
        </section>
      </div>
    </main>

    <footer><img src={logo} alt="Layla Food" /><p>Fast Food. Family Food. Layla Food.</p><div><Link to="/">Startseite</Link><Link to="/datenschutz">Datenschutz</Link><a href="mailto:info@layla-food.de">info@layla-food.de</a></div></footer>
  </div>
);

export default ImprintPage;
